export default {
	//对象
	state: {
		userInfo: {
			// //基本信息
			// buyer: {},
			// //帐户信息
			// account: {},
			// //订购信息
			// buyerSubscriber: {},
			// //当前版本所拥有的功能权限
			// functionObj:[],
		},
		buyerInfo:null,
		token: localStorage.getItem('ACCESS-TOKEN')||'',
	},
	//操作对象 相当于JAVA中的set方法 绝对不允许出现异步
	mutations: {
		setUserInfo(state, payload) {
			state.userInfo = payload;
		},
		setToken(state, payload) {
			state.token = payload;
		},
		setBuyerInfo(state, payload) {
			state.buyerInfo = payload;
		}
	},
	//提交的是mutations而不是直接变更状态，相当于直接操作了一次mutations，不同的是可以异步
	actions: {
		syncUserInfo(context, vue) {
			//此处可能会存在一个问题，同一浏览器更换账号了，账号显示就会有问题
      //注释的代码是为了解决同一浏览器更换了登录帐号显示的BUG
			// const userInfo = sessionStorage.getItem("BUYER-USER-INFO");
			// if(!userInfo){
				vue.$http.getUserInfoDatas().then(res=>{
					sessionStorage.setItem("BUYER-USER-INFO",JSON.stringify(res.data))
					context.commit('setUserInfo', res.data); //context提交
				}).catch(err=>{ })
			// }else{
			// 	context.commit('setUserInfo', JSON.parse(userInfo)); //context提交
			// }
		},
		//清空sessionStorage里面的用户信息
		clearUserInfo(context, vue){
			// vue.$http.getUserInfoDatas().then(res=>{
			// 	sessionStorage.setItem("BUYER-USER-INFO",JSON.stringify(res))
			// 	context.commit('setUserInfo', res); //context提交
			// }).catch(err=>{ })
			sessionStorage.removeItem("BUYER-USER-INFO");
					context.commit('setUserInfo', {
				//基本信息
				buyer: {},
				//帐户信息
				account: {},
				//订购信息
				buyerSubscriber: {},
				//当前版本所拥有的功能权限
				functionObj:[],
			}); //context提交
		},
		syncToken(context, data) {
			data.vue.$http.getUserToken(data.params)
			.then(res=>{
				localStorage.setItem("ACCESS-TOKEN",res.data)
				context.commit('setToken', res.data); //context提交
			})
			.catch(err=>{})
		},
		syncBuyerInfo(context, vue) {
			vue.$http.getBuyerInfo()
			.then(res=>{
				sessionStorage.setItem("BUYER-INFO",JSON.stringify(res.data))
				context.commit('setBuyerInfo', res.data); //context提交				
			})
			.catch(err=>{})
		}
	},
	//store的计算属性，理解为所有组件的computed属性，返回值会根据它的依赖被缓存起来，且只有当它的依赖值发生了改变才会被重新计算。
	getters: {
		getUserInfo: (state) => {
			let param=JSON.parse(sessionStorage.getItem('BUYER-USER-INFO'))
			state.userInfo = param||{}
			return state.userInfo;
		},
		getBuyerInfo: (state) => {
			let param=JSON.parse(sessionStorage.getItem('BUYER-INFO'))
			state.buyerInfo = param||{}
			return state.buyerInfo;
		},
		// getBuyerInfo: (state) => {
		// 	let param=JSON.parse(sessionStorage.getItem('BUYER-USER-INFO'))
		// 	state.userInfo.buyer = param.buyer||{}
		// 	return state.userInfo.buyer;
		// },
		// getAccountInfo: (state) => {
		// 	let param=JSON.parse(sessionStorage.getItem('BUYER-USER-INFO'))
		// 	state.userInfo.account = param.account||{}
		// 	return state.userInfo.account;
		// },
		// getBuyerAccountInfo: (state) => {
		// 	let param=JSON.parse(sessionStorage.getItem('BUYER-USER-INFO'))
		// 	state.userInfo.buyerAccount = param.buyerAccount||{}
		// 	return state.userInfo.buyerAccount;
		// },
		// getSubscriberInfo: (state) => {
		// 	let param=JSON.parse(sessionStorage.getItem('BUYER-USER-INFO'))
		// 	state.userInfo.buyerSubscriber = param.buyerSubscriber||{}
		// 	return state.userInfo.buyerSubscriber;
		// },
		// getFunctionInfo: (state) => {
		// 	let param=JSON.parse(sessionStorage.getItem('BUYER-USER-INFO'))
		// 	state.userInfo.functionObj = param.functionObj||[]
		// 	return state.userInfo.functionObj;
		// },
		getToken: (state) => {
			let param=localStorage.getItem('ACCESS-TOKEN')
			state.token = param||''
			return state.token;
		},		
	}
};



// WEBPACK FOOTER //
// ./src/vuex/user-info.js